import { useState, useEffect } from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import Parser from 'html-react-parser';
import Carousel from "../Components/Carousel/Carousel";
import StrapiBlocksRenderer from "../Components/StrapiBlocksRenderer/StrapiBlocksRenderer";
import FinishScreen from "./FinishScreen";
import CustomSkills from "../Components/Skills/CustomSkills";
import { useAuthContext } from "../context/AuthContext";
import { API } from "../constant";
import { getToken } from "../helpers";


const AssessmentQuiz = (props) =>{
    const [start, setStart]=useState(0);
    const [showReview, setShowReview] = useState(false);
    const [showFinish, setShowFinish] = useState(false);
    const [userAnswers, setUserAnswers] = useState({});
    const [isFavorited, setIsFavorited] = useState(false);
    const [favoriteLoading, setFavoriteLoading] = useState(false);

    const { user } = useAuthContext();

    // Handle starting the skill - scroll to top and push history state
    const handleStartSkill = () => {
        window.scrollTo(0, 0);
        window.history.pushState({ screen: 'skill' }, '');
        setStart(1);
    };

    // Handle browser back button
    useEffect(() => {
        const handlePopState = (event) => {
            if (start === 1 && !showReview && !showFinish) {
                // Go back to intro screen
                setStart(0);
                window.scrollTo(0, 0);
            } else if (showReview && !showFinish) {
                // Go back to carousel from review
                setShowReview(false);
                window.scrollTo(0, 0);
            } else if (showFinish) {
                // Go back to review from finish
                setShowFinish(false);
                window.scrollTo(0, 0);
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, [start, showReview, showFinish]);

    // Scroll to top when screen changes
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [start, showReview, showFinish]);
    const firstScreen = props.Content.dc[0];
    const steps = props.Content.dc[0].steps;
    console.log(props.Content);

    console.log(props);

    // Check if skill is already favorited
    useEffect(() => {
        const checkFavoriteStatus = async () => {
            if (!user || !props.SkillId) return;
            try {
                const response = await fetch(`${API}/users/${user.id}?populate=skills`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${getToken()}`,
                    }
                });
                const data = await response.json();
                const isAlreadyFavorited = data.skills?.some(skill => skill.id === props.SkillId);
                setIsFavorited(isAlreadyFavorited);
            } catch (error) {
                console.error("Error checking favorite status:", error);
            }
        };
        checkFavoriteStatus();
    }, [user, props.SkillId]);

    // Handle favorite toggle
    const handleFavorite = async () => {
        if (!user || !props.SkillId) return;
        setFavoriteLoading(true);
        try {
            const skillResponse = await fetch(`${API}/users/${user.id}?populate=skills`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${getToken()}`,
                }
            });
            const responseSkillData = await skillResponse.json();
            let relatedSkills = responseSkillData.skills?.map(item => ({ id: item.id })) || [];

            const existingIndex = relatedSkills.findIndex(item => item.id === props.SkillId);
            if (existingIndex > -1) {
                relatedSkills.splice(existingIndex, 1);
                setIsFavorited(false);
            } else {
                relatedSkills.push({ id: props.SkillId });
                setIsFavorited(true);
            }

            await fetch(`${API}/users/${user.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${getToken()}`,
                },
                body: JSON.stringify({ skills: relatedSkills }),
            });
        } catch (error) {
            console.error("Error updating favorite:", error);
        } finally {
            setFavoriteLoading(false);
        }
    };

    // Extract skill IDs from custom_skills_first and custom_skills_last
    const skillIdsFirst = props.Content.custom_skills_first?.data?.map(skill => skill.id) || [];
    const skillIdsLast = props.Content.custom_skills_last?.data?.map(skill => skill.id) || [];

    console.log('skillIdsFirst:', skillIdsFirst);
    console.log('skillIdsLast:', skillIdsLast);

    // Handle textarea changes
    const handleAnswerChange = (stepIndex, questionKey, value) => {
        setUserAnswers(prev => ({
            ...prev,
            [`step${stepIndex}_${questionKey}`]: value
        }));
    };

    const carouselItems= steps.map((item, index)=>{
        const abbreviation = firstScreen.abbreviation?.[index];
        return(
        <div className="carousel-item" key={index}>
            <div className="carousel-item-inner">
                <div className="item-content">
                <h4>{abbreviation ? `${abbreviation.abbr} - ${abbreviation.title}` : props.Content.Title || ''}</h4>
                <h2 className="carousel-item-title">{item.title}</h2>
                <StrapiBlocksRenderer blocks={item.description} />
                {item.question1?<h2 className="question">{item.question1}</h2>:""}
                {item.question1?<textarea
                    placeholder="Begin typing here..."
                    name={`dearmanStep1${index}`}
                    onChange={(e) => handleAnswerChange(index, 'question1', e.target.value)}
                    value={userAnswers[`step${index}_question1`] || ''}
                ></textarea>:""}
                {item.question2?<h2 className="question">{item.question2}</h2>:""}
                {item.question2?<textarea
                    placeholder="Begin typing here..."
                    name={`dearmanStep1${index + 1}`}
                    onChange={(e) => handleAnswerChange(index, 'question2', e.target.value)}
                    value={userAnswers[`step${index}_question2`] || ''}
                ></textarea>:""}
            </div>
        </div>
    </div>);
    })

    const abbr= firstScreen.abbreviation.map((item, index)=>{
        return( 
        <div className="step-item fade-in-down" style={{animationDelay: `${index * .3}s`}}>
            <div className="abbr">{item.abbr}</div>
            <div className="right-content">
                <h4>{item.title}</h4>
                <p>{item.short_description}</p>
            </div>
        </div> 
        );
    })
   console.log(carouselItems)
    
    const introScreen =
    <div className={`skills ${props.Slug}`} >
        <div className="container">
            <Header  type="primary"/>
            <div className="content-wrap bg-gradient-light">
                <div className="content-wrap-inner">
                    <div className="intro-box">
                        <div className="content">
                            <div className="intro-content">
                            {props.Content.Title?<h2>{props.Content.Title}</h2>:""}
                            {props.Content.sub_title?<h4>{props.Content.sub_title}</h4>:""}
                            <StrapiBlocksRenderer blocks={props.Content.description_main} />
                            </div>
                            {abbr?<div className="steps">{abbr}</div>:""}

                            {skillIdsFirst.length > 0 && (
                                <div className="suggested-skills-section">
                                    <h3>Suggested Skills</h3>
                                    <CustomSkills skillIds={skillIdsFirst} />
                                </div>
                            )}

                            <button className={`button-right-arrow hover-bounce ${abbr?"":"mt---30"}`} onClick={handleStartSkill}>Start {props.Content.Title} <span className="arrow-right"></span></button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    </div>;

    const mainScreen =
    <div className={`skills skills-carousel ${props.Slug}`} >
        <div className="container">
            <Header  type="primary"/>
            <div className="content-wrap bg-gradient-light">
                <div className="content-wrap-inner">
                    <Carousel
                        Items={carouselItems}
                        onFinish={() => {
                            window.history.pushState({ screen: 'review' }, '');
                            setShowReview(true);
                        }}
                    />
                </div>
            </div>
            <Footer />
        </div>
    </div>;

    const reviewScreen = (
        <div className={`skills review-screen ${props.Slug}`}>
            <div className="container">
                <Header type="primary" />
                <div className="content-wrap bg-gradient-light">
                    <div className="content-wrap-inner">
                        <div className="intro-box review-box">
                            <div className="content">
                                <h2>Review Your Answers</h2>
                                <h4>Please review your responses before submitting. Take a screenshot to save your responses to practice later as they will not
be saved after leaving this page</h4>

                                <div className="answers-review">
                                    {steps.map((item, index) => {
                                        const answer1 = userAnswers[`step${index}_question1`];
                                        const answer2 = userAnswers[`step${index}_question2`];

                                        return (
                                            <div key={index} className="review-item">
                                                <h3 className="review-step-title">Step {index + 1}: {item.title}</h3>

                                                {item.question1 && (
                                                    <div className="review-question-block">
                                                        <h4 className="review-question">{item.question1}</h4>
                                                        <div className="review-answer">
                                                            {answer1 || <span className="no-answer">No answer provided</span>}
                                                        </div>
                                                    </div>
                                                )}

                                                {item.question2 && (
                                                    <div className="review-question-block">
                                                        <h4 className="review-question">{item.question2}</h4>
                                                        <div className="review-answer">
                                                            {answer2 || <span className="no-answer">No answer provided</span>}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>

                                <div className="review-buttons">
                                    <button
                                        className="button-right-arrow hover-bounce"
                                        onClick={() => {
                                            window.history.pushState({ screen: 'finish' }, '');
                                            setShowFinish(true);
                                        }}
                                    >
                                        Finish <span className="arrow-right"></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        </div>
    );

    const finishScreenView = (
        <FinishScreen
            title="Activity is Complete!"
            subtitle={`You've finished the ${props.Content.Title || ''} Skill`}
            message="Well done! You've successfully completed all the questions."
            buttonText="Back to Activities"
            buttonLink="/ChooseOption"
            className={props.Slug}
            showFavorite={true}
            isFavorited={isFavorited}
            onFavorite={handleFavorite}
            favoriteLoading={favoriteLoading}
            customContent={
                skillIdsLast.length > 0 ? (
                    <div className="suggested-skills-section">
                        <h3>Continue with these suggested skills</h3>
                        <CustomSkills skillIds={skillIdsLast} />
                    </div>
                ) : null
            }
        />
    );

    if (showFinish) return finishScreenView;
    if (showReview) return reviewScreen;
    return start?mainScreen:introScreen;
}
export default AssessmentQuiz;